export const APP_NAME = 'LandOS';
export const APP_DESCRIPTION =
  'LandOS powers planetary restoration by providing carbon developers, landowners, and scientists with advanced mapping tools to assess land potential and develop carbon projects for the carbon markets.';
